import { createContext, useContext } from "react";

/**
 * `default` is the look from before the new navigation, `flat` the new one.
 */
export type ApplicationBarVariant = "default" | "flat";

export const ApplicationBarVariantContext =
    createContext<ApplicationBarVariant>("default");

export const useApplicationBarVariant = () =>
    useContext(ApplicationBarVariantContext);
